import { forwardRef } from 'react'
import styled from 'styled-components'

import Header from './Header'
import Content from './Content'
import Footer from './Footer'
import Awards from './Awards'
import AnotherLanguage from 'components/Common/AnotherLanguage'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  word-break: break-word;
  overflow-wrap: break-word;
`

const TechListPreview = forwardRef(({ product, lng, actions }, ref) => {
  return (
    <AnotherLanguage lng={lng}>
      <Wrapper ref={ref}>
        <Header product={product} actions={actions} />
        <Content product={product} />
        <Awards product={product} />
        <Footer product={product} />
      </Wrapper>
    </AnotherLanguage>
  )
})

export default TechListPreview
